import React from "react";

import history from "../router/history";

import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles({
  root: {
    width: 200,
    margin: "auto",
  },
  media: {
    height: 300,
  },
  title: {
    textOverflow: "ellipsis",
    width: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
});

export default function ReadingListCard(props) {
  const classes = useStyles();

  const openBookReadingPage = (bookId) => {
    history.push(`/ReadingList/${bookId}`);
  };

  return (
    <Card className={classes.root}>
      <CardActionArea onClick={() => openBookReadingPage(props.id)}>
        <CardMedia
          className={classes.media}
          image={props.cover}
          title="Contemplative Reptile"
        />
        <CardContent>
          <Typography variant="body1" className={classes.title}>
            {props.title}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {props.rating === 0 ? "N/A ★" : props.rating.toFixed(1) + " ★"}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
